import React from 'react';
import { HiXMark } from 'react-icons/hi2';
import { withTheme } from '../ThemeProvider';
import { Title } from './Title';
import { StyledCloseButton, StyledHeader } from './styles';

export interface IModalHeader {
  title?: string | React.ReactNode;
  icon?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  theme?: any;
}

const HeaderComponent: React.FC<IModalHeader> = ({ title, icon, onClick, className }) => {
  return (
    <StyledHeader className={className}>
      {typeof title === 'string' ? <Title title={title} icon={icon} /> : title}
      <StyledCloseButton onClick={onClick}>
        <HiXMark size={16} />
      </StyledCloseButton>
    </StyledHeader>
  );
};

export const Header = withTheme(HeaderComponent);
